export default __webpack_public_path__ + "static/media/Maus-mit-Luftballon.efa22286.webp";